import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putServiceProduct = async ({ serviceId, productId, qty, date }: JsonDataItem) => {
  const { data } = await baseQuery('service-product', {
    type: 'PUT',
    body: {
      service_id: serviceId,
      service_product_id: productId,
      quantity: qty,
      completion_date: date,
    },
  });

  return data;
};
